module.exports = __webpack_public_path__ + "img/tool.3bffa598.svg";